import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule, FormAlertModule } from '@com-delta-idp/mnx-ui-kit';
import { LoginHeaderModule } from '../../shared/login-header/login-header.module';
import { CheckEmailComponent } from './check-email.component';

@NgModule({
  declarations: [CheckEmailComponent],
  imports: [CommonModule, ButtonModule, LoginHeaderModule, FormAlertModule],
  exports: [CheckEmailComponent]
})
export class CheckEmailModule {}
